import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IStudentEnrollmentInfo } from '../../interfaces/istudent-enrollment-info';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@core/enums/permissions';
import { InputRatingAction } from '@core/enums/input-rating-action';
import { Router } from '@angular/router';
import { RatingService } from '@core/services/rating.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-student-info',
    templateUrl: './student-info.component.html',
    styleUrls: ['./student-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StudentInfoComponent implements OnInit {
  @Input() studentInfo?: IStudentEnrollmentInfo;
  @Input() hasMeasures: boolean = false;
  @Input() canLock = false;
  @Input() isScantron = false;
  @Input() isRatingDisabled = false;
  @Input() isRatingViewRejected = false;
  @Output() actionClicked = new EventEmitter();
  ratingViewRejectedMessage = this.translocoService.translate('shared.ratingPeriods.ratingViewRejected');
  canLockRatings = this.permissionService.checkPermission(
    Permission.LockRatings
  );
  previousPage = '/ratings';

  canUnlockRatings = this.permissionService.checkPermission(
    Permission.UnlockRatings
  );
  canSaveRatings = this.permissionService.checkPermission(
    Permission.CreateRating
  );
  public get Permission() {
    return Permission;
  }

  public get InputRatingAction() {
    return InputRatingAction;
  }

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private ratingService: RatingService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    const context = this.ratingService.getSearchContext();
    const classId = context?.classId ?? this.studentInfo?.classId;
    const ageGradeInstrumentId = context?.ageGradeInstrumentId ?? 0;
    this.previousPage = `ratings/class/${classId}/ageGradeInstrument/${ageGradeInstrumentId}`;
  }

  onActionClick(type: InputRatingAction) {
    this.actionClicked.emit(type);
  }

  goBack(): void {
    this.router.navigateByUrl(this.previousPage);
  }
}
